import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

interface StorageItem {
  key: string;
  value: string;
}

@Component({
  selector: 'app-debug-local-storage',
  templateUrl: './debug-local-storage.component.html',
  styleUrls: ['./debug-local-storage.component.css']
})
export class DebugLocalStorageComponent implements OnInit, OnChanges {
  @Input() isVisible = false;
  @Output() closed = new EventEmitter<void>();

  public storageItems: StorageItem[] = [];

  ngOnInit() {
    this.refreshData();
  }

  ngOnChanges() {
    if (this.isVisible) {
      this.refreshData();
    }
  }

  public refreshData() {
    this.storageItems = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key) || '';
        this.storageItems.push({ key, value });
      }
    }
    this.storageItems.sort((a, b) => a.key.localeCompare(b.key));
  }

  public clearStorage() {
    if (confirm('Are you sure you want to clear all local storage? This action cannot be undone.')) {
      localStorage.clear();
      this.refreshData();
    }
  }

  public removeItem(key: string) {
    if (confirm(`Are you sure you want to remove "${key}" from local storage?`)) {
      localStorage.removeItem(key);
      this.refreshData();
    }
  }

  public closeModal() {
    this.closed.emit();
  }
}